import React, { useState, useEffect } from "react";
import { Button, Card, Col, Modal, Row, Select, Table } from "antd";
import PropTypes from "prop-types";
import { sanitizeFieldName } from "../../util/methods";
import AccessControl from "../AccessControl";

const { Option } = Select;
const getColumns = (columns, resource = '') => {
    const filterCol = Object.keys(columns).map(item => {
        if (columns[item].options && columns[item].options.notVisible) {
            return null;
        }
        if (item === '_id' || item === 'password' || item === 'superAdmin') {
            return null;
        }
        return <Option key={columns[item].field}
            value={columns[item].field}>{item === 'soNo' ? 'SI No' : item === 'poNo' ? 'PI No' : item === 'grnDate' ? 'MGRN Date' : resource === 'Fuel' && columns[item].field === 'mileage' ? 'Meter Reading' : resource === 'Fuel' && columns[item].field === 'isFullTank' ? 'Considered as Full Tank' : sanitizeFieldName(columns[item].field)}</Option>;
    });
    if (resource && resource === 'SparesIssue') {
        filterCol.push(<Option key='location'
            value="location">Location</Option>);
    }
    if (resource && resource === 'PurchaseOrder') {
        filterCol.push(<Option key='totalAmount'
            value="totalAmount">Total Amount</Option>);
        filterCol.push(<Option key='createdBy'
            value="createdBy">Created By</Option>);
        filterCol.push(<Option key='lastUpdatedBy'
            value="lastUpdatedBy">Last Updated By</Option>);
    }
    if (resource && resource === 'Fuel') {
        filterCol.push(<Option key='ownerCode'
            value="ownerCode">Owner Code</Option>);
    }

    if (resource && resource === 'AssetModel') {
        filterCol.push(<Option key='idealFuelConsumptionRate'
            value="idealFuelConsumptionRate">Idle Fuel Consumption Rate</Option>);
    }
    return filterCol;
};

const List = ({
    title,
    columns,
    data,
    handleChange,
    columnChange,
    clearFilter,
    create,
    size,
    pagination,
    loading,
    filters,
    authUser,
    visibleColumn,
    seeReport,
    downloadToCSV,
    importPage,
    bulkDelete
}) => {

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [isRendering, setIsRendering] = useState(false)

    useEffect(() => {
        if (loading) {
            setIsRendering(true)
        } else {
            const timeoutId = setTimeout(() => {
                setIsRendering(false)
            }, 500) // Adjust the delay duration as needed

            return () => clearTimeout(timeoutId)
        }
    }, [loading, data])

    // Reset selectedRowKeys when data changes (new page, filter, etc.)
    useEffect(() => {
        setSelectedRowKeys([])
    }, [data])

    // Reset selectedRowKeys when pagination changes
    useEffect(() => {
        if (pagination && pagination.current) {
            setSelectedRowKeys([])
        }
    }, [pagination])

    const bulkDeleteProcess = (ids) => {
        // console.log(ids)
        if (ids && ids.length && bulkDelete) {
            Modal.confirm({
                title: `Confirm selected records to delete?`,
                content: <div>Are you sure to delete all {ids.length} records?</div>,
                okText: 'Yes I\'m sure',
                cancelText: 'Cancel',
                width: '55%',
                confirmLoading: true,
                onOk: () => {
                    bulkDelete(ids);
                    // Reset selection after bulk delete
                    setSelectedRowKeys([])
                }
            });

        }
    }

    const onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        setSelectedRowKeys(selectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <Card className={`gx-card-metrics`}>
            <div className=''>
                <div className='action-bar'>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <AccessControl resource={title} permissionNeeded={'c'}
                                roles={authUser ? authUser.roles : []} render={(props) => {
                                    return (title !== 'Asset' && title !== 'Activity' && title !== 'Log' && title !== 'QrScanLog' && title !== 'Notification' && title !== 'PreVerificationApproval') ?
                                        <Button type='primary' onClick={create} icon='add'> Add
                                            New {title !== 'AssetStockTaking'
                                                && sanitizeFieldName(title === 'Interval' ? 'meterUnit' : title === 'Client' ? 'Sub Location' :
                                                    title === 'PurchaseOrder' ? 'purchaseInvoice' : title === 'SaleOrder' ? 'salesInvoice'
                                                        : title === 'ThirdPartyWorkRequirement' ? 'TPW'
                                                            : title === 'ThirdPartyWorkQuotation' ? 'Quote' : title === 'AssetTransferAdvice' ? 'ATA'
                                                                : title === 'PMChecklist' ? 'PM Checklist' : title === 'PMSchedule' ? 'PM Schedule' : title === 'AssetClassification' ? 'Asset Category' : title)}</Button> : null
                                }} />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <AccessControl resource={title} permissionNeeded={'c'}
                                roles={authUser ? authUser.roles : []} render={(props) => {
                                    return (title === 'AssetTransferAdvice' && importPage ?
                                        <Button type='dashed' onClick={importPage} icon='upload'>Bulk
                                            Import</Button> : null)
                                }} />
                        </Col>

                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <AccessControl resource={title} permissionNeeded={'c'}
                                roles={authUser ? authUser.roles : []} render={(props) => {
                                    return (title !== 'Activity' && title !== 'Log' && title !== 'Resource') ?
                                        <Button icon={'download'} style={{ marginRight: '10px' }}
                                            disabled={columns.length <= 1}
                                            onClick={downloadToCSV}>Download
                                            to CSV</Button> : <></>
                                }} />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <AccessControl resource={title} permissionNeeded={'r'}
                                roles={authUser ? authUser.roles : []} render={(props) => {
                                    return (visibleColumn && visibleColumn.length ?
                                        (<Select mode="multiple" maxTagCount={1} key={'1'}
                                            style={{ width: '200px', marginRight: '10px' }}
                                            placeholder="Visible Columns"
                                            defaultValue={visibleColumn}
                                            onChange={columnChange}>
                                            {getColumns(filters, title)}
                                        </Select>)
                                        : (<Select mode="multiple" maxTagCount={1} key={'2'}
                                            style={{ width: '200px', marginRight: '10px' }}
                                            placeholder="Visible Columns"
                                            defaultValue={visibleColumn}
                                            onChange={columnChange}>
                                            {getColumns(filters, title)}
                                        </Select>))
                                }} />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <Button onClick={clearFilter}>Clear filters and sorters</Button>
                        </Col>
                    </Row>

                </div>

                <Table style={
                    {
                        overflow: "auto"
                    }
                }
                    scroll={
                        {
                            x: 1650
                        }
                    }
                    columns={columns}
                    dataSource={data}
                    onChange={handleChange}
                    size={size}
                    rowKey={'_id'}
                    pagination={pagination}
                    loading={{
                        spinning: loading || isRendering,
                        tip: 'Loading data, please wait...',
                    }}
                    rowSelection={bulkDelete ? rowSelection : null}
                />
                <div className='action-bar'>
                    {title === 'Fuel' && bulkDelete &&
                        <AccessControl resource={title} permissionNeeded={'d'}
                            roles={authUser ? authUser.roles : []} render={(props) => {
                                return <Button disabled={!selectedRowKeys || !selectedRowKeys.length} type='danger'
                                    onClick={() => bulkDeleteProcess(selectedRowKeys)}
                                    icon='delete'>{`Delete ${selectedRowKeys.length} records`}</Button>
                            }} />
                    }
                </div>
            </div>
        </Card>
    )
};

export default List;
List.defaultProps = {
    size: "middle"
};

List.propTypes = {
    title: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    columnChange: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired,
    size: PropTypes.string,
    data: PropTypes.array.isRequired,
    create: PropTypes.func,
    pagination: PropTypes.object,
    loading: PropTypes.bool,
    filters: PropTypes.object,
    visibleColumn: PropTypes.array
};
